import { IApplicationState } from '../../types/redux';

export const selectConstructionProgress = (state: IApplicationState) => {
  const { constructionProgress } = state.constructionProgressData;

  return constructionProgress;
};
